// Authentication servisi - API çağrıları
import axios from 'axios';

// API base URL'i
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Hata yönetimi
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token geçersiz, kullanıcıyı logout yap
      localStorage.removeItem('token');
      // Sayfa refresh'ini engelle, sadece token'ı temizle
      // window.location.href = '/login'; // Bu satırı kaldırdık
    }
    return Promise.reject(error);
  }
);

// Authentication servis fonksiyonları
export const authService = {
  // Giriş yapma
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Çıkış yapma
  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      throw error;
    }
  },

  // Token doğrulama
  async verifyToken() {
    try {
      const response = await api.get('/auth/profile');
      return response.data.user;
    } catch (error) {
      throw error;
    }
  },

  // Şifre sıfırlama isteği
  async forgotPassword(email) {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Şifre sıfırlama token doğrulama
  async verifyResetToken(token) {
    try {
      const response = await api.post('/auth/verify-reset-token', { token });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Yeni şifre belirleme
  async resetPassword(token, password) {
    try {
      const response = await api.post('/auth/reset-password', { token, password });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Profil güncelleme
  async updateProfile(profileData) {
    try {
      const response = await api.put('/auth/profile', profileData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
